import { formatLocalYmd } from './dates';

export type CachedTopic = {
  id: string;
  title: string;
  play_date: string;
  description?: string | null;
  source_1?: string | null;
  source_2?: string | null;
  source_3?: string | null;
};

export type CachedAnswer = {
  id: string;
  name: string;
  rank: number;
  name_2?: string | null;
  name_3?: string | null;
};

export type CachedPuzzle = {
  loadedOn: string;
  topic: CachedTopic;
  answers: CachedAnswer[];
  prevTopic: { title: string; play_date: string } | null;
  nextTopic: { title: string; play_date: string } | null;
};

const store = new Map<string, CachedPuzzle>();

export function cacheKey(archiveDate: string | null) {
  return archiveDate || formatLocalYmd();
}

export function getCachedPuzzle(targetDate: string): CachedPuzzle | null {
  const today = formatLocalYmd();
  const hit = store.get(targetDate);
  if (!hit) return null;
  // Today's puzzle from yesterday's tab session is stale after midnight.
  if (targetDate === today && hit.loadedOn !== today) {
    store.delete(targetDate);
    return null;
  }
  return hit;
}

export function setCachedPuzzle(
  targetDate: string,
  data: Omit<CachedPuzzle, 'loadedOn'>
) {
  store.set(targetDate, { ...data, loadedOn: formatLocalYmd() });
}
